import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { toast } from "sonner";
import { fetchSchoolNotifications } from "../../lib/schools";
import { formatApiError } from "../../lib/api";
import { ReadableCard } from "../Sticker";
import { SectionTitle } from "../createEvent/CreateEventFormUi";

function formatWhen(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export default function SchoolNotificationsSection() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const items = await fetchSchoolNotifications();
        if (!cancelled) setNotifications(items);
      } catch (e) {
        if (!cancelled) toast.error(formatApiError(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) return null;
  if (!notifications.length) return null;

  return (
    <ReadableCard className="p-4 space-y-3 mt-6">
      <SectionTitle icon={Bell}>School updates</SectionTitle>
      <ul className="space-y-2">
        {notifications.slice(0, 8).map((n) => (
          <li
            key={n.id || n._id}
            className="rounded-lg border border-black/8 px-3 py-2 text-sm"
          >
            <p className="text-ink">{n.message}</p>
            <p className="text-xs text-ink/50 mt-1">{formatWhen(n.created_at)}</p>
          </li>
        ))}
      </ul>
    </ReadableCard>
  );
}
